import type {CSS} from '@pinecast/styles';
import styled from '@pinecast/styles';

import Spinner from './Spinner';
import type {LocalizedReactNode} from './types';

const Wrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding: '40px 0',
  textAlign: 'center',
});
const TextWrapper = styled('div');

const LoadingState = ({
  title,
  style,
}: {
  title: LocalizedReactNode;
  style?: CSS;
}) => (
  // The title says what is loading, so it is the status and the spinner only
  // decorates it.
  <Wrapper role="status" style={style}>
    <Spinner decorative type="focus" style={{marginBottom: 20}} />
    <TextWrapper>{title}</TextWrapper>
  </Wrapper>
);

export default LoadingState;
